var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-overlay',{attrs:{"value":_vm.overlay}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}})],1),_vm._v(" "),_c('v-card',[_c('v-toolbar',{staticClass:"indigo lighten-3",attrs:{"flat":"","dark":""}},[_c('v-toolbar-title',[_vm._v("Roles")])],1),_vm._v(" "),_c('v-card-text')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }